import { graphql } from '../graphql';

/** Slim on purpose — polled. Never add inputJson/outputJson here (D12). */
export const analysisRunsQuery = graphql(`
  query AnalysisRuns($projectId: ID!, $types: [ProcessJobType!]) {
    analysisRuns(projectId: $projectId, types: $types) {
      id
      batchId
      groupId
      type
      status
      name
      createdAt
      finishedAt
      resultLayerId
      inputLayerIds
      error
    }
  }
`);

/** Downloadable files of the project's runs (in-batch byproducts + linked
 *  standalone report PDFs). Do NOT poll: the server reads report job inputJson
 *  keys. No URL — resolve one on click via batch(id).byproducts (5-min presign).
 *  A report covering two runs appears once per run: key by (runId, id). Pass
 *  the same `types` as analysisRunsQuery (same server-side run window). */
export const analysisRunFilesQuery = graphql(`
  query AnalysisRunFiles($projectId: ID!, $types: [ProcessJobType!]) {
    analysisRunFiles(projectId: $projectId, types: $types) {
      id
      runId
      batchId
      filename
      type
      contentLength
      createdAt
    }
  }
`);

/** Lazy, one row, on Re-run click only. */
export const analysisRunInputQuery = graphql(`
  query AnalysisRunInput($jobId: ID!) {
    analysisRunInput(jobId: $jobId)
  }
`);

/** The run-details drawer: one run's batch and its jobs, polled every 2 s
 *  while the run is active. Slim on purpose — NOT `getBatch`, which selects
 *  every job's inputJson/outputJson/logs. Never add those (or `errorLogs`) here:
 *  `errorPreview` is the first 500 characters. `logStream` is a short
 *  CloudWatch URL (staff-only debug link), fine to poll. */
export const analysisRunDetailsQuery = graphql(`
  query AnalysisRunDetails($id: ID!) {
    batch(id: $id) {
      id
      key
      status
      createdAt
      processingStartedAt
      processingCompletedAt
      totalBytes
      createdBy {
        id
        name
        email
        avatar {
          id
          url
        }
      }
      jobs {
        id
        type
        status
        parentItemId
        startedAt
        completedAt
        attempts
        errorPreview
        logStream
      }
    }
  }
`);
